module.exports = __webpack_public_path__ + "static/media/NuLifeSpan.Walmart.top.Mar.25.adabe72e.pdf";